export const socketConnectionOptions = env => {
    const options = {
        broadcaster: 'pusher',
        key: env.VITE_APP_SOCKET_KEY,
        cluster: env.VITE_APP_SOCKET_CLUSTER,
    };
    const host = env.VITE_APP_SOCKET_HOST?.trim();

    if (!host) return options;

    const forceTLS = env.VITE_APP_SOCKET_SCHEME !== 'http';
    const configuredPort = Number(env.VITE_APP_SOCKET_PORT);
    const port =
        Number.isInteger(configuredPort) && configuredPort > 0 && configuredPort <= 65535
            ? configuredPort
            : forceTLS
              ? 443
              : 80;

    return {
        ...options,
        // Pusher's SDK requires a cluster even when a custom host supplies the endpoint.
        cluster: options.cluster || 'mt1',
        wsHost: host,
        wsPort: port,
        wssPort: port,
        forceTLS,
        enabledTransports: ['ws', 'wss'],
    };
};
